import React, {useEffect, useState } from "react";
import { getMyLeaves } from "../../utils/helper";
import Loader from "../../utils/Loader";

export default function MyLeaves() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);

    useEffect(() => {
        setLoading(true);
        getMyLeaves()
            .then((res) => { 
                setData(res.data.data);  
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => {
                console.log(err?.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    return (
        <>
            <h1 className="dash-title">Learning and Development</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Leave Requests</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && data && data) ? 
                                    <div className="table-responsive">
                                        {(data && data.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Organization</th><th>Title</th><th>Year</th><th>Month</th><th>Date</th><th>Time</th>
                                            <th>Action</th></tr></thead>
                                            <tbody>
                                                {data && data.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{row?.organization?.name && row?.organization?.name}</td>
                                                        <td>{row?.title && row?.title}</td>
                                                        <td>{row?.year && row?.year}</td>
                                                        <td>{row?.month && row?.month}</td>
                                                        <td>{row?.date && row?.date}</td>
                                                        <td>{row?.time && row?.time}</td> 
                                                        <td>
                                                            <a href={`${row.meeting_link}`} 
                                                                className='btn btn-review'
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                <i className="fa fa-external-link"></i> Join Meeting
                                                            </a>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No record found.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
